
import { useEffect } from "react";
import React from "react";
import { supabase } from "@/integrations/supabase/client";
import { BookingFormData } from "../../ParcelBookingForm";
import { parsePhoneNumber } from "react-phone-number-input";
import { useContactBook } from "@/hooks/contact/useContactBook";

export const useProfileSync = (
  setFormData: React.Dispatch<React.SetStateAction<BookingFormData>>
) => {
  const { savedContacts, refetch } = useContactBook();

  useEffect(() => {
    const fetchUserProfile = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('name, phone_number, email')
          .eq('id', user.id)
          .single();

        if (profile) {
          const contactData = {
            isMyself: true,
            name: profile.name || '',
            phone: '',
            email: profile.email || '',
            isPrimary: true,
            sortOrder: 0
          };

          let phoneForForm = '';
          if (profile.phone_number) {
            // Add '+' prefix if not present
            const phoneNumberWithPrefix = profile.phone_number.startsWith('+') 
              ? profile.phone_number 
              : `+${profile.phone_number}`;
            
            const parsedNumber = parsePhoneNumber(phoneNumberWithPrefix);
            if (parsedNumber) {
              console.log("Parsed phone number:", parsedNumber);
              console.log("Country:", parsedNumber.country);
              phoneForForm = phoneNumberWithPrefix;
            }
          }

          if (phoneForForm) {
            contactData.phone = phoneForForm;
          }

          // Initialize with first contact being the user's profile
          setFormData(prev => ({
            ...prev,
            collectionContacts: [contactData]
          }));

          // Create or update "Myself" contact in the contact book
          const myselfContact = savedContacts.find(c => c.label === 'Myself');
          if (!myselfContact && profile.name && phoneForForm) {
            try {
              await supabase
                .from('contact_book')
                .upsert({
                  user_id: user.id,
                  name: profile.name,
                  phone: phoneForForm,
                  email: profile.email,
                  label: 'Myself',
                  is_saved: true
                }, { onConflict: 'user_id,label' });
                
              // Refetch contacts to update the list
              refetch();
            } catch (error) {
              console.error("Error creating Myself contact:", error);
            }
          }
        }
      }
    };

    fetchUserProfile();
  }, [setFormData]); // Removed savedContacts and refetch to prevent infinite loop

  return {};
};
